module.exports = __webpack_public_path__ + "static/media/myskills.76950569.png";